/** Colors for trailer paths in route map and route analysis (up to 10 unique, then cycles) */
export const ROUTE_PATH_COLORS = [
    '#1976d2',
    '#2e7d32',
    '#ed6c02',
    '#9c27b0',
    '#00838f',
    '#c62828',
    '#f9a825',
    '#3949ab',
    '#d81b60',
    '#6d4c41',
] as const;
